import * as React from "react";
import { themePalette } from "../../theme";

export const ExpandLessIcon = ({
  color = themePalette.blueDark,
}: React.SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 8.29498L6.705 13.59L8.12 15.005L12 11.125L15.88 15.005L17.295 13.59L12 8.29498Z"
      fill={color}
    />
  </svg>
);
